<template>
  <div data-vbox="vbox-root">
    <slot></slot>
  </div>
</template>
<script>
import Activity from "@/activity/Activity";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import {addListener} from "resize-detector";

const breakpointNames = ["xl", "lg", "md", "sm", "xs"];
let breakpointValues = null;

const bootstrapDetectBreakpoint = function () {
  // cache some values on first call
  if (!breakpointValues) {
    breakpointValues = []
    for (const breakpointName of breakpointNames) {
      breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName)
    }
  }
  let i = breakpointNames.length
  for (const breakpointName of breakpointNames) {
    i--
    if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
      return {name: breakpointName, index: i}
    }
  }
  return null
}


export default {
  name: "VBox",

  async created() {

  },
  mounted() {
    if(this.delayedInit){
      return;
    }
    this.$onEvent(Events.sizeChanged, () => this.sizeChanged());
    this.sizeChanged();
  },


  methods: {

    delayedInitialize(){
      this.$onEvent(Events.sizeChanged, () => this.sizeChanged());
      this.sizeChanged();
    },
    // simplified
    findRelativeParentTopOffset(el) {
      if (getComputedStyle(el.parentElement).position == "relative") {
        return el.parentElement.offsetTop + el.offsetTop;
      } else {
        return el.offsetTop;
      }
    },

    sizeChanged() {
      // console.log(`!!!! ${this.vbName} vb 1`);
      if(window['__stop']){
        throw new Error("STOP!!");
      }

      if (!this.autoSize) {
        // console.log(`!!!! ${this.vbName} vb 2`);
        return;
      }

      if(this.pending){
        // console.log(`!!!! ${this.vbName} vb 3`);
        return;
      }
      this.pending = true;
//          window.requestAnimationFrame(() => {

          this.pending = false;
          if (!this.activityRootDiv) {
            // console.log(`!!!! ${this.vbName} vb 4`);

            this.activityRootDiv = Activity.findActivityRootDiv(this.$el);
            if (!this.activityRootDiv) {
              return;
            }

          }
          if(this.nested == null){
            // console.log(`!!!! ${this.vbName} vb 5`);

            let el = this.$el.parentNode;
            this.nested = false;
            while(el){
              if(el?.dataset?.vbox === 'vbox-root'){
                this.nested = true;
                break;
              }
              el = el.parentNode;
            }
          }
          if(this.nested){
            // console.log(`!!!! ${this.vbName} vb 6`);
            return;
          }

          if (!this.workspaceRoot) {
            // console.log(`!!!! ${this.vbName} vb 7`);
            this.workspaceRoot = Activity.findWorkspaceRootElement(this.$el);
            if (!this.workspaceRoot) {
              return;
            }
          }

          if(!this.isVisible()){
            // console.log(`!!!! ${this.vbName} vb 7.5 - NOT VIS`);
            return;
          }
      // console.log(`!!!! ${this.vbName} vb 8`);

          let beforeBreakpoint = true;
          if (this.breakpoint && this.breakpoint != 'xs') {
            let currentBreakpoint = bootstrapDetectBreakpoint();
            let breakpointIndex = breakpointNames.indexOf(this.breakpoint);

            if (currentBreakpoint.index < breakpointIndex) {
              this.height = this.alternateHeight;
              beforeBreakpoint = false;
            }
          }
      // console.log(`!!!! ${this.vbName} vb 9: ${beforeBreakpoint}`);

          if (beforeBreakpoint) {

            if (getComputedStyle(this.$el).position === "absolute") {
              // console.log(`!!!! ${this.vbName} vb 10`);

              //
              // let containerHeight = this.workspaceRoot.getBoundingClientRect().top;
              // let contentHeight = this.activityRootDiv.offsetHeight - this.$el.parentElement.offsetTop;

              this.height = this.workspaceRoot.offsetHeight - (this.$el.parentElement.getBoundingClientRect().top - this.activityRootDiv.getBoundingClientRect().top) - 1;
              if (this.height > 2000) {
                this.height = 200;
              }
              // console.log(`!!!! ${this.vbName} vb 11 ${this.height}`);

            } else {
              // console.log(`!!!! ${this.vbName} vb 12`);

              let containerHeight = this.workspaceRoot.offsetHeight;
              let rootDiv = this.activityRootDiv;
              let contentHeight = rootDiv.offsetHeight - this.$el.offsetHeight;
              //this.height = this.workspaceRoot.offsetHeight - (this.$el.getBoundingClientRect().top -  this.activityRootDiv.getBoundingClientRect().top) - 1;
              // Log.debug(`VBox h: ${containerHeight - contentHeight - 1} = ${containerHeight} - ${contentHeight} - 1`)
              this.height = containerHeight - contentHeight - 1;
              // console.log(`!!!! ${this.vbName} vb 13 ${this.height}`);

            }
            if (this.height < 200) {
              this.height = 200;
            }
            if (this.height > 2000) {
              this.height = 2000;
            }
          }
      // console.log(`!!!! ${this.vbName} vb 14 ${this.height}`);

          let resized = this.$el;
          let el = this.$el;
          if (el.firstChild) {
            for(let child=el.firstChild; child!==null; child=child.nextSibling) {
              if(child.nodeType === Node.ELEMENT_NODE){
                resized = child;
                break;
              }
            }
          }
      // console.log(`!!!! ${this.vbName} vb 15 ${this.height}`);

      //         ActivityManager.holdResizeObservers();
          try{
            let st = "display:block; height:" + this.height + "px; max-height: 100%; margin-bottom:0px; margin-top:0px;" + (this.scrollable ? " overflow-y:auto;" : "") + this.contentStyle;
            if(resized?.__vue__?.$data?.baseStyle != null){
              resized.__vue__.$data.baseStyle = st;
            }
            resized.style = st;

            this.$emit('resize', this.height);
            //Log.debug(`VBox style: ${resized.style}`)
          } finally {
           // ActivityManager.reactivateResizeObservers();
          }
      //  })
      // });
    },
    isVisible(){
      let node =  this.$el;
      while(node && node != document.body){
        let st = getComputedStyle(node);
        if(st.display === "none"){
          return false;
        }
        node = node?.parentNode;
      }
      return true;

    }
  },

  props: {
    scrollable: {type: Boolean, default: false},
    breakpoint: {type: String, default: 'xs'},
    alternateHeight: {type: Number, default: 200},
    autoSize: {type: Boolean, default: true},
    contentStyle: {type: String, default: ""},
    vbName: {type: String, default: ""},
    delayedInit: {default: false}
  },

  data: () => ({
    height: 300,
    nested: null,
    workspaceRoot: null,
    activityRootDiv: null
  })
}
</script>
